// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { DnaSyngoviaConnectionRect } from '../../interfaces/dna-syngovia-connection-rect';
import { AbstractChartMapService } from './abstract-chart-map.service';
import { DigitalProductChartMapSevice } from './digital-product-chart-map.service';

@Injectable({
  providedIn: 'root',
})
export class ClientChartMapService extends AbstractChartMapService {
  public constructor(
    private readonly digitalProductChartMapSevice: DigitalProductChartMapSevice,
  ) {
    super();
  }

  public override calculateRectValues(
    rects: DnaSyngoviaConnectionRect[],
    row = 0,
    column = 0,
  ): {
    row: number;
    column: number;
  } | void {
    return this.digitalProductChartMapSevice.calculateRectValues(
      rects,
      row,
      column,
    );
  }

  protected override calculateLinePath(
    rect: DnaSyngoviaConnectionRect,
    row: number,
    column: number,
  ): string | null {
    return this.digitalProductChartMapSevice['calculateLinePath'](
      rect,
      row,
      column,
    );
  }
}
